import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import HeroSquaresMb from '../../../images/company/hero-squares-mb.png';
import HeroSquares from '../../../images/company/hero-squares.png';
import {
  MainStyled,
  TextColumn,
  Title,
  Subtitle,
  ImageColumn,
  DiagonalBlueData,
} from './style';

interface Props {}

const Main: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <MainStyled>
      <div className="content">
        <ImageColumn className="animate__animated animate__fadeIn">
          <img src={HeroSquares} alt="background" />
        </ImageColumn>
        <TextColumn className="animate__animated animate__fadeIn">
          <Title>{t('CompanyMainTitle')}</Title>
          <Subtitle
            dangerouslySetInnerHTML={{
              __html: t('CompanyMainSubtitle'),
            }}
          />
        </TextColumn>
      </div>
      <DiagonalBlueData />
      <img src={HeroSquaresMb} alt="background" />
    </MainStyled>
  );
};

export default Main;
